// src/pages/AboutPage.jsx

import React from 'react';
import Navbar from '../components/navbar';
import Footer from '../components/footer';
import '../styles/aboutUs.css';
import useScrollAnimation from '../hooks/useScrollAnimation';
import { PHARMACY_NUMBER } from '../constants/constant';
import { formatPhoneNumber } from '../utils/phoneFormatter';

function AboutPage() {
  useScrollAnimation();

  return (
    <>
      <Navbar />

      <section className="about-page">
        <div className="about-hero fade-in">
          <h1>About Us</h1>
          <p>Locally owned and operated pharmacy where you get “Right service at Right time”.</p>
        </div>

        <div className="about-content">
          <div className="about-image slide-left">
            <img src="/assets/cameron_2.jpg" alt="Mirror Lake Pharmacy" />
            {/* <img src="/assets/about_us.png" alt="Mirror Lake Pharmacy" /> */}
          </div>

          <div className="about-text slide-up-delay-1">
            <h2>Pharmacist-Led Care</h2>
            <p>
              RPh Cameron Delong has been serving the city of Camrose for more than 9 years. With vast experience in geriatric care and prescribing for patients’ health needs, he is committed to excellence in pharmacy service.
            </p>

            <h2>Why Mirror Lake Pharmacy?</h2>
            <ul>
              <li>The "right service at right time"</li>
              <li>Walk-in clinic available 7 days a week</li>
              <li>Friendly and knowledgeable staff</li>
              <li>Committed to the Camrose community</li>
            </ul>

            <h2>Contact Information</h2>
            <ul>
              <li><strong>Phone:</strong> <a href={`tel:${PHARMACY_NUMBER}`}>{formatPhoneNumber(PHARMACY_NUMBER)}</a></li>
              <li><strong>Email:</strong> <a href="mailto:mirrorlakepharmacy@gmail.com">mirrorlakepharmacy@gmail.com</a></li>
              <li><strong>Location:</strong> <a
                href="https://www.google.com/maps/dir/?api=1&destination=5403+48+Ave+Unit+103,+Camrose,+AB+T4V+0J6"
                target="_blank"
                rel="noopener noreferrer"
              >Unit#103, 5403 48 Ave, Camrose</a></li>
              {/* TODO */}
              <li><strong>Website:</strong> <a href="https://www.mirrorlakepharmacy.ca/">www.mirrorlakepharmacy.ca</a></li>
            </ul>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default AboutPage;